import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import Analytics from 'APP_ROOT/services/analytics';
import Events from '../../common/events';
import Globals from '../../common/globals';
import { strings, getCurrentLocale } from '../../../localization';

export default class LoginPage extends Component {

    static propTypes = {
        onLogin: PropTypes.func.isRequired,
        features: PropTypes.object,
        errorMessage: PropTypes.string,
        pendingInvite: PropTypes.object
    }

    constructor(props) {

        super(props);

        this.state = {
            emailValid: true,
            passwordValid: true
        }
    }

    componentDidMount() {
        Analytics.pageView();
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE)); //hide loading page if coming from another logged in page and was kicked out due to inactive/no session.
        if(this.email){
            if(this.props.pendingInvite){
                this.email.setAttribute('disabled', true);
                this.email.value = this.props.pendingInvite.inviteEmail;
            }
            else{
                this.email.focus();
            }
        }
    }

    handleEmailChange = (e, force = false) => {

        this.validateEmail(e.target.value, force);
    }

    handlePasswordChange = (e, force = false) => {

        this.validatePassword(e.target.value, force);
    }

    validateEmail = (value, force) => {

        var emailValid = false;

        if (!this.state.emailValid || force) {
            var longEnough = value.length > 0;
            var indexOfAt = value.indexOf('@');
            var charBeforeAt = value.slice(0, indexOfAt).length > 0;
            var charAfterAt = value.slice(indexOfAt, value.length - 1).length > 0;

            emailValid = longEnough && indexOfAt > -1 && charBeforeAt && charAfterAt;
            this.setState({ emailValid: emailValid });
        }

        return emailValid;
    }

    validatePassword = (value, force) => {

        var passwordValid = false;

        if (!this.state.passwordValid || force) {
            passwordValid = value.length > 0;
            this.setState({ passwordValid: passwordValid });
        }

        return passwordValid;
    }

    renderEmailField = () => {
        return (
            <>
                <input
                     ref={(email) => { this.email = email; }} 
                     id="username" 
                     type="email" 
                     name="email"
                     className={this.state.emailValid ? '' : 'invalid'} 
                     onChange={this.handleEmailChange} onBlur={(e) => { this.handleEmailChange(e, true) }} 
                />
                {this.state.emailValid ? <p className="error-message">&nbsp;</p> : <p className="error-message">{strings.formatString(strings.sign_in_email_invalid)}</p>}
            </>
        )

    }

    render() {

        var signinname = strings.formatString(strings.sign_in);
        var specialMessage = null;
        if (window.location.search.indexOf("return_to") > -1) {
            signinname = strings.formatString(strings.sign_in_support);
        }
        if (window.location.search.indexOf("timeout") > -1) {
            specialMessage = (
                <p><i className="material-icons yellow">warning</i>{strings.formatString(strings.sign_in_expired)}</p>
            );
        }
        if (window.location.search.indexOf("error") > -1) {
            var search = window.location.search.replace(/%22/g, "\"");
            search = search.split('error=');
            specialMessage = (
                <p><i className="material-icons yellow">warning</i>{strings.formatString(strings[search[1]])}</p>
            );
        }

        return (
            <div id="loginPage" className="container login-page">

                <div className="row">
                    <div className="mx-auto login-form">
                        <form id="loginForm">
                            <h1>{signinname}</h1>
                            {specialMessage}
                            <div className="row">
                                <div className="col-12">
                                    <label htmlFor="username">{strings.formatString(strings.sign_in_email)}</label>
                                    {this.renderEmailField()}
                                </div>

                                <div className="col-12">
                                    <label htmlFor="password">{strings.formatString(strings.sign_in_password)}</label>
                                    <input ref={(password) => { this.password = password; }} id="password" type="password" name="password" className={this.state.passwordValid ? '' : 'invalid'} onChange={this.handlePasswordChange} onBlur={(e) => { this.handlePasswordChange(e, true) }} />
                                    {this.state.passwordValid ? <p className="error-message">&nbsp;</p> : <p className="error-message">{strings.formatString(strings.sign_in_password_invalid)}</p>}
                                </div>
                                <div className="col-12 content-group">
                                    <input className="btn" type="submit" onClick={(e) => this.props.onLogin(e, this.email.value, this.password.value, this.validateEmail, this.validatePassword)} value={strings.formatString(strings.sign_in)} /> <NavLink to={'/' + getCurrentLocale() + '/forgot-password'}>{strings.formatString(strings.title_activity_forgot_password)}?</NavLink>
                                    <div>{(this.props.errorMessage) ? (<p className="error-message"><i className="material-icons">error_outline</i><span>{this.props.errorMessage}</span></p>) : null}</div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                {this.props.features && this.props.features.splash_asset ?
                    <div className="vendor-splash-asset">
                        <img src={`${this.props.features.channel_branding_base_url || ''}/images/${this.props.features.splash_asset}`} alt="" />
                    </div>
                :
                    null
                }
            </div>
        );
    }
}
